export enum HubAssignmentSourceEnum {
  None = "None",
  Stored = "Stored",
  Calculated = "Calculated",
  Skip = "Skip",
}

export interface IBookingHubDisplay {
  effectiveHubId?: number;
  effectiveHubStationName?: string;
  hubSource: HubAssignmentSourceEnum;
  storedHubId?: number | null;
  isExplicitSkip: boolean;
}
